import Icon from './Icon';

const DevBlogPost = ({ post, onBack }) => {
  const date = new Date(post.created_at).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric',
  });

  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: '0 0 60px' }}>
      <button
        className="btn-ghost btn-sm"
        onClick={onBack}
        style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 24 }}
      >
        <Icon name="back" size={14} /> Back to Dev Blog
      </button>

      <article>
        {post.cover_image && (
          <img
            src={post.cover_image}
            alt=""
            style={{
              width: '100%', maxHeight: 360, objectFit: 'cover',
              borderRadius: 'var(--radius-xl)', marginBottom: 28,
              border: '1px solid var(--border)',
            }}
          />
        )}

        <h1 style={{
          fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 700,
          color: 'var(--text)', lineHeight: 1.25, marginBottom: 12,
        }}>
          {post.title}
        </h1>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 28, color: 'var(--text3)', fontSize: 13 }}>
          <span>{post.author_name}</span>
          <span>·</span>
          <span>{date}</span>
        </div>

        <div
          className="dev-blog-body"
          dangerouslySetInnerHTML={{ __html: post.body }}
          style={{ color: 'var(--text)', lineHeight: 1.75, fontSize: 15 }}
        />
      </article>
    </div>
  );
};

export default DevBlogPost;
